// ----------------------------------------------------------------------------
// Snippet: Search
// ----------------------------------------------------------------------------
// Search bar, on header and on the Search Results template.
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_search-form.scss';


const SEARCH_FORM = '.search-box';
const SEARCH_ICON = '.search-box__toggle';
const SEARCH_INPUT = '.search__input';
const SEARCH_CLOSE = '.search__close';
const PREDICTIVE_SEARCH = '#predictive-search';

document.addEventListener("DOMContentLoaded", function(){

    // If you click anywhere outside of the search, close it
    $('body').on('click', function(event) {
        if (!$(event.target).closest('.form--search').length && !$(event.target).closest(SEARCH_ICON).length) {
            $(SEARCH_FORM).removeClass('is-active');
            $(SEARCH_FORM).parent().removeClass('search__is-active');
            $(PREDICTIVE_SEARCH).hide();
        }
    });

    // When you click the close button, remove open class and clean input
    $(SEARCH_CLOSE).on('click', function(event) {
        $(SEARCH_FORM).removeClass('is-active');
        $(SEARCH_FORM).parent().removeClass('search__is-active');
        $(PREDICTIVE_SEARCH).hide();
        $(SEARCH_INPUT).val('');
    });

    // When you click the search icon, toggle the open state
    $(SEARCH_ICON).on('click', function (event) {
        event.preventDefault();

        let $currentParent = $(this).closest(SEARCH_FORM);

        $currentParent.toggleClass('is-active');
        $currentParent.parent().toggleClass('search__is-active');
        $currentParent.find(SEARCH_INPUT).focus();

        // Clear header classes for mobile
        $('.header').removeClass('js--isOpen');
        $('.menu--default').removeClass('js--isOpen');
        $('.header__link--menu').removeClass('js--isOpen');
        $('body').removeClass('noscroll');
    });

    document.addEventListener('keyup', function (e) {
        if (e.keyCode == 27 && $(SEARCH_INPUT).is(":focus")) {
            $(SEARCH_FORM).removeClass('is-active');
            $(SEARCH_FORM).parent().removeClass('search__is-active');
        }
    });

    // Allows label on mobile to also target the search
    $('.search-box--header .form__label').on('click', function (event) {
        $(this).closest('.search-box').toggleClass('is-active');
        $(this).closest('.search-box').parent().toggleClass('search__is-active');
    });

});
